

const ReturnDocumentTypes = [
    { name: "Goods Return Note", id: "grn" },
    { name: "Invoice", id: "invoice" },
    { name: "Delivery Note", id: "dnote" }
]

export default ReturnDocumentTypes;